const PAY_RATE_FORMATS = [
  'range',
  'exact_amount',
  'minimum_only',
  'maximum_only'
];

export default PAY_RATE_FORMATS;
